import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=2892ba2d&scoped=true"
import script from "./SummaryTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=2892ba2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892ba2d",
  null
  
)

export default component.exports